import PageTitle from "../../components/title/pageTitle";
import {Button, DatePicker, Input, Typography} from 'antd';

import Navigation from "../../components/navigation/navigation";
import Footer from "../../components/footer/footer";
import BackHomeIcon from "../../components/icons/BackHome/backhome";
import {useForm, ValidationError} from "@formspree/react";
import TextArea from "antd/es/input/TextArea";
import "./contact.css"
import {useEffect, useState} from "react";
import { useTranslation } from "../../i18n";
import { useWhiteLabel } from "../../whiteLabel/useWhiteLabel";

const {Title} = Typography;

function Contact() {
    const { t } = useTranslation();
    const { isWhiteLabel } = useWhiteLabel();
    const [state, handleSubmit] = useForm("xnnnolqz");
    const [dateValue, setDateValue] = useState("");
    const [showed, setShowed] = useState(false);

    useEffect(() => {
        if (state.succeeded && !showed) {
            alert(t("pages.contact.submitted"));
            setShowed(true);
            window.location.reload();
        }
    }, [state.succeeded, showed, t]);

    const onChange = (date, dateString) => {
        setDateValue(dateString);
    };


    return (<>
        <PageTitle>
            <Navigation></Navigation>
        </PageTitle>

        <BackHomeIcon></BackHomeIcon>

        {!isWhiteLabel && <>
            <div className={"custom-h1"} style={{marginLeft: "10%", marginRight: "10%"}}>
                <span>{t("pages.contact.title")}</span>
            </div>
            <div style={{marginLeft: "10%", marginRight: "10%", marginTop: "2rem"}}>

                <Title level={4} style={{fontSize: "large", textAlign: "center"}}>
                    {t("pages.contact.emailLabel")}
                    <a href={"mailto:contact@heicreative.co.uk"}>contact@heicreative.co.uk</a>
                </Title>
            </div>
            <div style={{marginLeft: "10%", marginRight: "10%", marginTop: "2rem"}}>

            <Title level={4} style={{textAlign:"center"}}>{t("pages.contact.formIntro")}</Title>
            </div>
            <div style={{marginLeft: "10%", marginRight: "10%"}}>
            <form onSubmit={handleSubmit}>
                <div className={"contact-row"}>
                    <Input className={"half"}
                           placeholder={t("pages.contact.firstName")}
                           id="firstName"
                           type="firstName"
                           name="firstName"
                    />
                    <Input className={"half"}
                           placeholder={t("pages.contact.lastName")}
                           id="lastName"
                           type="lastName"
                           name="lastName"
                    />
                </div>
                <div className={"contact-row"}>
                    <Input className={"half"}
                           placeholder={t("pages.contact.email")}
                           id="email"
                           type="email"
                           name="email"
                    />
                    <ValidationError
                        prefix={t("pages.contact.email")}
                        field="email"
                        errors={state.errors}
                    />
                    <DatePicker className={"half"}
                                placeholder={t("pages.contact.date")}
                                id="date"
                                type="date"
                                name="date"
                                multiple onChange={onChange} maxTagCount="responsive"/>
                </div>
                <div className={"contact-row"}>

                    <TextArea rows={4}
                              placeholder={t("pages.contact.message")}
                              id="message"
                              name="message"
                    />
                    <ValidationError
                        prefix={t("pages.contact.message")}
                        field="message"
                        errors={state.errors}
                    />
                </div>
                <div className={"contact-row"}>
                    <Button onClick={() => {
                        window.location.reload();
                    }}>
                        {t("common.clear")}
                    </Button>
                    <Button type="primary" htmlType="submit" disabled={state.submitting}>
                        {t("common.submit")}
                    </Button>
                </div>
                <input type="hidden" name="date" value={dateValue}/>

            </form>

        </div>
        </>}
        <Footer></Footer>
        </>
    );
}

export default Contact
